import { getHeroQuote } from "@/data/heroBackground";

/**
 * Full-bleed still for the homepage and the single-screen public cards.
 * Mounted once in the layout so the same image stays up across those routes.
 */
const HeroBackdrop = () => {
  const quote = getHeroQuote();

  if (!quote.image) return null;

  return (
    <div className="pointer-events-none fixed inset-0 -z-10" aria-hidden="true">
      <img
        src={quote.image}
        alt=""
        width={1280}
        height={720}
        fetchPriority="high"
        className="h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-slate-950/30" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent,rgba(15,23,42,0.45))]" />
    </div>
  );
};

export default HeroBackdrop;
